var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-grid-body-row",style:(`grid-column: span ${_vm.numCols}; grid-template-columns : repeat(${_vm.numCols}, 1fr);
          `)},[_c('div',{staticClass:"table-grid-body-row__cell align-center justify-center",style:(`grid-column: span ${(_vm.numCols )};`)},[_vm._v("\n    Нет данных\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }